import axiosClientFSR from "../axiosClientFSR";
export const objectLockFRS = {
    getList: (param) => {
        return axiosClientFSR.get("/objectlock/list", {
            params: param
        })
    },
    postAdd: (data) => {
        return axiosClientFSR.post("/objectlock/addMany", data)
    },
    deleteObject: (id) => {
        return axiosClientFSR.delete(`/objectlock/delete/${id}`)
    },
}